import { render, staticRenderFns } from "./iframes.vue?vue&type=template&id=2b03da6c"
import script from "./iframes.vue?vue&type=script&lang=js"
export * from "./iframes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b03da6c')) {
      api.createRecord('2b03da6c', component.options)
    } else {
      api.reload('2b03da6c', component.options)
    }
    module.hot.accept("./iframes.vue?vue&type=template&id=2b03da6c", function () {
      api.rerender('2b03da6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/routerView/iframes.vue"
export default component.exports